import React, { FunctionComponent } from 'react';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';

interface PaginationProps {
  pageSelected: number;
  totalPages: number;
  maxPagesToShow?: number;
  disabled?: boolean;
  onChange: (page: number) => void;
}

export const Pagination: FunctionComponent<PaginationProps> = ({
  pageSelected,
  totalPages,
  onChange,
  maxPagesToShow: mpts = 5,
}) => {
  const onClickPageButton = (page: number) => {
    if (page != pageSelected) {
      onChange(page);
    }
  };

  if (totalPages < 1) {
    return null;
  }

  const maxPagesToShow = mpts < 1 ? 5 : mpts % 2 === 0 ? mpts - 1 : mpts;

  const generatePageNumbers = () => {
    if (totalPages <= maxPagesToShow) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    if (pageSelected <= Math.ceil(maxPagesToShow / 2)) {
      return Array.from({ length: maxPagesToShow }, (_, i) => i + 1);
    }

    if (pageSelected >= totalPages - Math.floor(maxPagesToShow / 2)) {
      return Array.from({ length: maxPagesToShow }, (_, i) => totalPages - maxPagesToShow + 1 + i);
    }

    return Array.from({ length: maxPagesToShow }, (_, i) => pageSelected - Math.floor(maxPagesToShow / 2) + i);
  };

  return (
    <nav>
      <ul className="table-pagination justify-content-center mt-3 mb-3">
        {pageSelected > 1 && (
          <li className="page-item">
            <span onClick={() => onClickPageButton(pageSelected - 1)}>
              <IoIosArrowBack />
            </span>
          </li>
        )}
        {pageSelected > 3 && (
          <>
            <li className="page-item">
              <span className="page-link" onClick={() => onClickPageButton(1)}>
                1
              </span>
            </li>
            <li style={{ cursor: 'default' }}>...</li>
          </>
        )}
        {generatePageNumbers().map((page) => (
          <li key={page} className={`page-item ${page === pageSelected ? 'active' : ''}`}>
            <span className="page-link" onClick={() => onClickPageButton(page)}>
              {page}
            </span>
          </li>
        ))}
        {pageSelected <= totalPages - 3 && (
          <>
            <li style={{ cursor: 'default' }}>...</li>
            <li className="page-item">
              <span className="page-link" onClick={() => onClickPageButton(totalPages)}>
                {totalPages}
              </span>
            </li>
          </>
        )}
        {pageSelected < totalPages && (
          <li className="page-item">
            <span className="page-link" onClick={() => onClickPageButton(totalPages)}>
              <IoIosArrowForward />
            </span>
          </li>
        )}
      </ul>
    </nav>
  );
};
